/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGuid } from '../models/custom-result-of-list-of-guid';
import { CustomResultOfListOfKeyValuePairOfIntegerAndString } from '../models/custom-result-of-list-of-key-value-pair-of-integer-and-string';
import { CustomResultOfListOfMenuClaimDto } from '../models/custom-result-of-list-of-menu-claim-dto';
import { CustomResultOfPaginatedListOfRoleListItemDto } from '../models/custom-result-of-paginated-list-of-role-list-item-dto';
import { CustomResultOfRoleControllerClaimsDto } from '../models/custom-result-of-role-controller-claims-dto';
import { rolesAddOrUpdateRoleUsers } from '../fn/roles/roles-add-or-update-role-users';
import { RolesAddOrUpdateRoleUsers$Params } from '../fn/roles/roles-add-or-update-role-users';
import { rolesClone } from '../fn/roles/roles-clone';
import { RolesClone$Params } from '../fn/roles/roles-clone';
import { rolesCreateGet } from '../fn/roles/roles-create-get';
import { RolesCreateGet$Params } from '../fn/roles/roles-create-get';
import { rolesCreatePost } from '../fn/roles/roles-create-post';
import { RolesCreatePost$Params } from '../fn/roles/roles-create-post';
import { rolesDelete } from '../fn/roles/roles-delete';
import { RolesDelete$Params } from '../fn/roles/roles-delete';
import { rolesGetRoles } from '../fn/roles/roles-get-roles';
import { RolesGetRoles$Params } from '../fn/roles/roles-get-roles';
import { rolesGetRoles2 } from '../fn/roles/roles-get-roles-2';
import { RolesGetRoles2$Params } from '../fn/roles/roles-get-roles-2';
import { rolesGetRolesAudit } from '../fn/roles/roles-get-roles-audit';
import { RolesGetRolesAudit$Params } from '../fn/roles/roles-get-roles-audit';
import { rolesGetRolesWithPagination } from '../fn/roles/roles-get-roles-with-pagination';
import { RolesGetRolesWithPagination$Params } from '../fn/roles/roles-get-roles-with-pagination';
import { rolesGetRoleUsers } from '../fn/roles/roles-get-role-users';
import { RolesGetRoleUsers$Params } from '../fn/roles/roles-get-role-users';
import { rolesUpdateGet } from '../fn/roles/roles-update-get';
import { RolesUpdateGet$Params } from '../fn/roles/roles-update-get';
import { rolesUpdatePut } from '../fn/roles/roles-update-put';
import { RolesUpdatePut$Params } from '../fn/roles/roles-update-put';

@Injectable({ providedIn: 'root' })
export class RolesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `rolesGetRolesAudit()` */
  static readonly RolesGetRolesAuditPath = '/Roles/GetRolesAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRolesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesGetRolesAudit$Response(params: RolesGetRolesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return rolesGetRolesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetRolesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesGetRolesAudit(params: RolesGetRolesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.rolesGetRolesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `rolesGetRoles()` */
  static readonly RolesGetRolesPath = '/Roles/GetRoles';

  /**
   * For drop down.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoles$Response(params?: RolesGetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>> {
    return rolesGetRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * For drop down.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoles(params?: RolesGetRoles$Params, context?: HttpContext): Observable<CustomResultOfListOfKeyValuePairOfIntegerAndString> {
    return this.rolesGetRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>): CustomResultOfListOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

  /** Path part for operation `rolesGetRoles2()` */
  static readonly RolesGetRoles2Path = '/Roles/GetRoles/{organizationId}';

  /**
   * For drop down.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRoles2()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoles2$Response(params: RolesGetRoles2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>> {
    return rolesGetRoles2(this.http, this.rootUrl, params, context);
  }

  /**
   * For drop down.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetRoles2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoles2(params: RolesGetRoles2$Params, context?: HttpContext): Observable<CustomResultOfListOfKeyValuePairOfIntegerAndString> {
    return this.rolesGetRoles2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>): CustomResultOfListOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

  /** Path part for operation `rolesGetRolesWithPagination()` */
  static readonly RolesGetRolesWithPaginationPath = '/Roles/GetRolesWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRolesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesGetRolesWithPagination$Response(params: RolesGetRolesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfRoleListItemDto>> {
    return rolesGetRolesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetRolesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesGetRolesWithPagination(params: RolesGetRolesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfRoleListItemDto> {
    return this.rolesGetRolesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfRoleListItemDto>): CustomResultOfPaginatedListOfRoleListItemDto => r.body)
    );
  }

  /** Path part for operation `rolesCreateGet()` */
  static readonly RolesCreateGetPath = '/Roles/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesCreateGet$Response(params?: RolesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfMenuClaimDto>> {
    return rolesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesCreateGet(params?: RolesCreateGet$Params, context?: HttpContext): Observable<CustomResultOfListOfMenuClaimDto> {
    return this.rolesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfMenuClaimDto>): CustomResultOfListOfMenuClaimDto => r.body)
    );
  }

  /** Path part for operation `rolesCreatePost()` */
  static readonly RolesCreatePostPath = '/Roles/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreatePost$Response(params: RolesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return rolesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreatePost(params: RolesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.rolesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `rolesUpdateGet()` */
  static readonly RolesUpdateGetPath = '/Roles/Update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesUpdateGet$Response(params: RolesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfRoleControllerClaimsDto>> {
    return rolesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesUpdateGet(params: RolesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfRoleControllerClaimsDto> {
    return this.rolesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfRoleControllerClaimsDto>): CustomResultOfRoleControllerClaimsDto => r.body)
    );
  }

  /** Path part for operation `rolesUpdatePut()` */
  static readonly RolesUpdatePutPath = '/Roles/Update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesUpdatePut$Response(params: RolesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return rolesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesUpdatePut(params: RolesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.rolesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `rolesClone()` */
  static readonly RolesClonePath = '/Roles/Clone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesClone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesClone$Response(params: RolesClone$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return rolesClone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesClone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesClone(params: RolesClone$Params, context?: HttpContext): Observable<CustomResult> {
    return this.rolesClone$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `rolesDelete()` */
  static readonly RolesDeletePath = '/Roles/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDelete$Response(params?: RolesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return rolesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDelete(params?: RolesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.rolesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `rolesGetRoleUsers()` */
  static readonly RolesGetRoleUsersPath = '/Roles/GetRoleUsers/{roleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRoleUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoleUsers$Response(params: RolesGetRoleUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGuid>> {
    return rolesGetRoleUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGetRoleUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoleUsers(params: RolesGetRoleUsers$Params, context?: HttpContext): Observable<CustomResultOfListOfGuid> {
    return this.rolesGetRoleUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGuid>): CustomResultOfListOfGuid => r.body)
    );
  }

  /** Path part for operation `rolesAddOrUpdateRoleUsers()` */
  static readonly RolesAddOrUpdateRoleUsersPath = '/Roles/AddOrUpdateRoleUsers/{roleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesAddOrUpdateRoleUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesAddOrUpdateRoleUsers$Response(params: RolesAddOrUpdateRoleUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return rolesAddOrUpdateRoleUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesAddOrUpdateRoleUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesAddOrUpdateRoleUsers(params: RolesAddOrUpdateRoleUsers$Params, context?: HttpContext): Observable<CustomResult> {
    return this.rolesAddOrUpdateRoleUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
